import React from 'react';
import MuiInfoIcon from '@mui/icons-material/InfoOutlined';

export const InfoIcon = React.forwardRef((props: any, ref) => <MuiInfoIcon ref={ref} {...props} />);
InfoIcon.displayName = 'InfoIcon';
